import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;
  /* margin-left: -15px; */
  position: relative;
  width: 100%;
  /* width: calc(100% + 15px); */

  .infiniteScroll {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    margin: auto;
  }
  /* @media (max-width: 650px) {
    margin-left: 0;
    width: 100%;
  } */
`
